module.exports = __webpack_public_path__ + "static/image/lesson_path_1.svg?41da3fb4c4a12637b53cb1187b313734";